<template>
  <div style="max-width: 1200px">
    <template v-if="userIsAuthorized && userHasOrga">
      <div class="section" style="margin-top: -50px">
        <h1 class="is-size-3" style="margin-bottom: 20px">
          <span v-html="$gettext('start.headline')"></span>
        </h1>

        <div style="margin-bottom: 2rem">
          <span v-html="$gettext('start.intro')"></span>
        </div>

        <!--
          v-if really doesn't work here because the locale update seems
          to conflict with the vue update cycle. with v-if you get frequent
          errors about nodes not being found
        -->
        <div v-show="hasNews" class="leuris-news fob-box">
          <h2>
            <b-icon icon="exclamation"></b-icon>
            <translate>leuris news heading</translate>
          </h2>
          <div v-html="news"></div>
        </div>

        <div>
          <h2 class="is-size-5" style="margin-bottom: 0.5em">
            <span class="has-text-weight-bold" v-html="$gettext('start.help.heading')"></span>
          </h2>
          <div
            style="margin-bottom: 20px"
            v-html="$gettext('start.help')"
          ></div>
        </div>

        <div class="buttons is-centered" style="margin: 0px 0 30px 40px">
          <a class="control button is-link is-outlined" :href="wikiLink('start', 'das_allerwichtigste_in_kuerze')" target="_blank" >
            <translate>start.help.intro</translate>
            <b-icon icon="external-link" size="is-small"/>
          </a>
          <a class="control button is-link" :href="wikiLink('haeufige_fragen')" target="_blank">
            <translate>start.help.faq</translate>
            <b-icon icon="external-link" size="is-small"/>
          </a>
        </div>

        <div style="margin-bottom: 20px;">
          <translate>start.video.tutorials.text</translate>
        </div>
        <div class="buttons is-centered" style="margin: 0px 0 30px 40px">
          <a class="control button is-link is-outlined" href="https://schulung.uni-leipzig.de/leuris-schulung" target="_blank" >
            <translate>start.video.tutorials.link</translate>
            <b-icon icon="external-link" size="is-small"/>
          </a>
        </div>

        <template v-if="userIsAuthorized">
          <h2 class="is-size-5" style="margin-bottom: 0.5em">
            <span class="has-text-weight-bold">
              <translate>start.firstSteps.heading</translate>
            </span>
          </h2>

          <div v-translate :v-translate-params="{ renderedRouterLinkListActivities }">start.firstSteps</div>

          <div class="buttons is-centered" style="margin: 30px 0 30px 40px">
            <router-link class="control button is-medium has-text-basalt is-medium" :to="{name: 'auflisten'}">
              <b-icon size="is-small" icon="table"></b-icon>
              <span v-html="$gettext('start.listSavedViews')"></span>
            </router-link>
            <router-link class="control button is-medium has-text-basalt is-medium" :to="{name: 'eintragen'}">
              <b-icon size="is-small" icon="pencil-square-o"></b-icon>
              <span>
                <span v-html="$gettext('start.addActivity')"></span>
              </span>
            </router-link>
            <!-- <router-link class="control button is-medium has-text-basalt is-medium" to="/berichte">
              <b-icon size="is-small" icon="list-ul"></b-icon>
              <span>
                Eigene Forschungsberichte verwalten
              </span>
            </router-link> -->
          </div>
          <div style="margin-bottom: 20px; margin-top: 40px">
            <h2 class="is-size-5">
              <span class="has-text-weight-bold" v-html="$gettext('start.shortcuts')"></span>
            </h2>
          </div>

          <fob-saved-views style="margin-left: 40px"></fob-saved-views>
        </template>

        <template v-else>
          <div>
            Um die Weboberfläche nutzen zu können, müssen Sie sich
            zunächst <router-link to="/login">einloggen.</router-link>
          </div>
        </template>
      </div>
    </template>
    <!-- USER HAS NO ORGA -->
    <template v-else-if="userIsAuthorized && !userHasOrga">
      <div style="padding: 1rem; max-width: 1200px;">
        <div class="columns">
          <div class="column" style="max-width: 50px;">
            <b-icon icon="exclamation" type="is-aquamarine" size="is-large"></b-icon>
          </div>
          <div class="column">
            <translate>start.noOU</translate>
            <a :href="`mailto:fob@uni-leipzig.de?subject=${subject}`">
              <b-icon icon="envelope" size="is-small"> </b-icon> <translate>FOB-Team</translate>
            </a>
            .
          </div>
        </div>
      </div>
    </template>

    <div class="content has-text-centered" style="margin-top: 3rem">
      <div class="is-size-7 has-text-grey-light">
        <span style="padding-right: 0.5rem;">FOBGUI {{version}}</span>
        <a v-if="this.hasUpdateAvailable" class="has-text-grey-light" style="padding-right: 0.5rem;" @click="reloadPage" :title="$gettext('ReloadPage')"><translate>UpdateAvailable</translate></a>
        <a v-if="this.userIsAuthorized" class="has-text-grey-light" style="padding-right: 0.5rem;" @click="dropLocalStorage">Browserspeicher löschen</a>
      </div>
    </div>
  </div>
</template>

<script>
import SavedViews from '@/components/SavedViews'
import DynamicTitle from '@/components/mixins/DynamicTitle'
import ExternalLinkProvider from '@/components/mixins/ExternalLinkProvider'
import { isLowerVersion } from '@/utils'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'hello',
  mixins: [DynamicTitle, ExternalLinkProvider],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.start'
      },
      hasNews: false,
      news: '',
      leurisNews: {
        de: '',
        en: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      userIsAuthorized: 'user/isAuthorized',
      userHasOrga: 'user/hasOrga',
      version: 'getVersion',
      serverVersion: 'getServerVersion',
      userName: 'user/name'
    }),
    hasUpdateAvailable () {
      return isLowerVersion(this.version, this.serverVersion)
    },
    currentLocale () {
      return this.$language.current.substring(0, 2).toLowerCase()
    },
    renderedRouterLinkListActivities () {
      const route = this.$router.resolve({ name: 'auflisten' }, this.$route)
      const linkText = this.$gettext('menu.list')
      return `<a href="${route.href}">${linkText}</a>`
    },
    subject () {
      return encodeURIComponent(`[FOB] Keine Kostenstelle: ${this.userName}`)
    }
  },
  methods: {
    dropLocalStorage () {
      this.$dialog.confirm({
        title: 'Browserspeicher löschen',
        message: 'Sind Sie sicher, dass Sie alle im Browser gespeicherten FOB-relevanten Einstellungen <b>löschen</b> möchten? Diese Aktion kann nicht rückgängig gemacht werden!',
        cancelText: 'Abbrechen',
        confirmText: 'Speicher leeren',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          // remove localstorage
          window.localStorage.removeItem('de.ul.fob')
          this.$dialog.alert({
            message: 'Speicher geleert! Seite wird neu geladen.',
            type: 'is-danger',
            onConfirm: () => location.reload()
          })
        }
      })
    },
    reloadPage () {
      window.location.reload(true)
    }
  },
  mounted () {
    let news = [
      axios.get('/static/news/news_de.html')
        .then(res => res.data)
        .catch(() => ''),
      axios.get('/static/news/news_en.html')
        .then(res => res.data)
        .catch(() => '')
    ]

    Promise.all(news)
      .then(([newsDe, newsEn]) => {
        this.leurisNews = {
          de: newsDe,
          en: newsEn
        }
        this.hasNews = this.leurisNews[this.currentLocale] !== ''
        this.news = this.leurisNews[this.currentLocale]
      })
  },
  watch: {
    currentLocale () {
      this.hasNews = this.leurisNews[this.currentLocale] !== ''
      this.news = this.leurisNews[this.currentLocale]
    }
  },
  components: {
    'fob-saved-views': SavedViews
  }
}
</script>

<style>
  .leuris-news {
    border: 1px solid #B02F2C;
    background-color: white;
    margin: 3em auto;
    width: 70%;
    border-radius: 6px;
  }
  
  .leuris-news p {
    margin-bottom: 1em;
  }
  
  .leuris-news b-icon {
    padding-left: 5em;
  }
  
  .leuris-news .icon {
    margin-right: 0.5em;
  }
  
  .leuris-news h2 {
    display: flex;
    align-items: center;
    font-size: 1.2em;
    background-color: #B02F2C;
    color: white;
    font-weight: 900;
    padding: 1rem 1rem;
  }

  .leuris-news strong {
	  color: #B02F2C;
	  font-size: 1.03em;
  }
  
  .leuris-news div {
    font-size: 1em;
    padding: 2rem 1rem;
  }

  .fob-box {
    box-shadow: 0 8px 6px -6px #777;
  }
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue